/**
 * queueSound — toca o som de alerta "novo atendimento atribuído a você".
 *
 * Uso:
 *   import { playQueueSound } from '@/modules/chat/utils/queueSound';
 *   playQueueSound();
 *
 * Padrão idêntico ao `messageSound.ts` — HTMLAudioElement é criado uma vez
 * e reaproveitado; `currentTime = 0` reinicia se eventos chegam em sequência;
 * `play()` pode rejeitar se o browser bloqueou autoplay antes de qualquer
 * interação do user (não fatal, apenas logamos).
 *
 * Disparado pelo socket event `CONVERSATION_ASSIGNED_TO_ME` (user-specific),
 * consumido no hook global [useConversationAssignedSocket].
 */

const SOUND_URL = '/assets/notifications/audio/queue.wav';

let cachedAudio: HTMLAudioElement | null = null;

function getAudio(): HTMLAudioElement {
  if (!cachedAudio) {
    cachedAudio = new Audio(SOUND_URL);
    cachedAudio.preload = 'auto';
  }
  return cachedAudio;
}

export function playQueueSound(): void {
  try {
    const audio = getAudio();
    audio.currentTime = 0;
    void audio.play().catch((err: unknown) => {
      console.debug('[queueSound] play() bloqueado/falhou:', err);
    });
  } catch (err: unknown) {
    console.debug('[queueSound] falha ao tocar:', err);
  }
}
